import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import {GameService} from "../../services/game.service";
import {LineUp} from "../../model/lineUp";
import {Player} from "../../model/players";
import { MatCheckboxChange, MatCheckbox } from "@angular/material/checkbox";
import {LineUpService} from "../../services/lineUp.service";
import {MatDialog} from "@angular/material/dialog";
import {DialogUpdatePlayerLineupComponent} from "../dialog-update-player-lineup/dialog-update-player-lineup.component";
import {Subscription} from "rxjs";
import {LoadingService} from "../../services/loading.service";
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';


@Component({
    selector: 'app-dialog-lineup',
    templateUrl: './dialog-lineup.component.html',
    styleUrls: ['./dialog-lineup.component.scss'],
    imports: [MatIconButton, MatIcon, MatCheckbox, FormsModule, TranslocoModule]
})
export class DialogLineupComponent implements OnInit, OnDestroy{
  lineUp = inject(LineUpService);
  game = inject(GameService);
  loadingService = inject(LoadingService);
  data = inject<{
    homeLineup: LineUp;
    awayLineup: LineUp;
}>(MAT_BOTTOM_SHEET_DATA);
  private _bottomSheetRef = inject<MatBottomSheetRef<DialogLineupComponent>>(MatBottomSheetRef);
  updatePlayerDialog = inject(MatDialog);

  public homeLineup: LineUp;
  public awayLineup: LineUp;
  public homeActiveStatuses: boolean[];
  public awayActiveStatuses: boolean[];
  public anyHomeActiveStatuses = false;
  public anyAwayActiveStatuses = false;
  private subscription: Subscription | undefined;

  constructor() {
    const data = this.data;

    this.homeLineup = data.homeLineup;
    this.awayLineup = data.awayLineup;

    this.homeActiveStatuses = this.homeLineup.activeStatuses
    this.awayActiveStatuses = this.awayLineup.activeStatuses
  }

  ngOnInit() {
    this.subscription = this.lineUp.lineupUpdates$.subscribe(() => {
      this.refreshLineUp();
    });
  }

  ngOnDestroy() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.subscription.unsubscribe();
  }

  refreshLineUp() {
    this.homeActiveStatuses = this.lineUp.home.activeStatuses
    this.awayActiveStatuses = this.lineUp.away.activeStatuses
    this.anyHomeActiveStatuses = this.homeActiveStatuses.some(x => x)
    this.anyAwayActiveStatuses = this.awayActiveStatuses.some(x => x)
    this.homeLineup = this.lineUp.home
    this.awayLineup = this.lineUp.away
  }

  getPlayerPositions(player: Player): string {
    return player.playerPositions.map(pos => pos.position).join(' - ');
  }

  onPlayerLineUpChange(event: MatCheckboxChange, player: Player, lineup: LineUp, index:number) {
    if (event.checked) {
      this.updateActiveStatus(lineup, index, true);
      this.lineUp.activatePlayerToLineUp(player, lineup);
      this.setPlayerGameStatus(player, true);
    } else {
      this.updateActiveStatus(lineup, index, false)
      this.lineUp.deactivatePlayerFromLineUp(player, lineup);
      this.setPlayerGameStatus(player, false);
    }
  }

  private setPlayerGameStatus(player: Player, isInGame:boolean) {
    if (this.game.isDemoGame()) return
    this.lineUp.setPlayerInGame(this.game.game.id, player, isInGame).subscribe();
  }

  private updateActiveStatus(lineup: LineUp, index: number, isActive:boolean) {
    if (lineup === this.homeLineup) {
      this.homeActiveStatuses[index] = isActive;
      this.anyHomeActiveStatuses = this.homeActiveStatuses.some(x => x)
    } else {
      this.awayActiveStatuses[index] = isActive;
      this.anyAwayActiveStatuses = this.awayActiveStatuses.some(x => x)
    }
  }

  close() {
    this._bottomSheetRef.dismiss();
  }

  addPlayerPopUp(teamId: string) {
    const updatePlayerDialogRef = this.updatePlayerDialog.open(DialogUpdatePlayerLineupComponent, {
      panelClass: 'dark-dialog',
      data: {
        isEdit: false,
        fullName: '',
        jerseyNumber: '',
        playerPositions: [],
        teamId,
        seasonId: this.homeLineup.teamId === teamId ? this.homeLineup.seasonId : this.awayLineup.seasonId
      }
    });

    updatePlayerDialogRef.afterClosed().subscribe(() => {
      this.loadingService.setLoading(true);
      this.lineUp.loadLineUp(this.game.game.id).subscribe(() => {
        this.refreshLineUp()
        this.loadingService.setLoading(false);
      });
    });
  }

  selectAllPlayers(lineup: LineUp, isChecked: boolean) {
    this.loadingService.setLoading(true);
    lineup.fullTeam.forEach((player, index) => {
      if (isChecked) {
        this.updateActiveStatus(lineup, index, true);
        this.lineUp.activatePlayerToLineUp(player, lineup);
        this.setPlayerGameStatus(player, true)
      } else {
        this.updateActiveStatus(lineup, index, false)
        this.lineUp.deactivatePlayerFromLineUp(player, lineup);
        this.setPlayerGameStatus(player, false);
      }
    });
    this.refreshLineUp();
    this.loadingService.setLoading(false);
  }

  editPlayerPopUp(player:Player) {
    const updatePlayerDialogRef = this.updatePlayerDialog.open(DialogUpdatePlayerLineupComponent, {
      panelClass: 'dark-dialog',
      data: {
        playerId: player.id,
        isEdit: true,
        fullName: player.fullName,
        jerseyNumber: player.gamesPlayed[0]?.gameJerseyNumber ? player.gamesPlayed[0]?.gameJerseyNumber : player.jerseyNumber,
        playerPositions: player.playerPositions,
        teamId: player.teamId,
        seasonId: player.seasonId
      }
    });

    updatePlayerDialogRef.afterClosed().subscribe(() => {
      this.loadingService.setLoading(true);
      this.lineUp.loadLineUp(this.game.game.id).subscribe(() => {
        this.refreshLineUp()
        this.loadingService.setLoading(false);
      });
    });
  }

  // editPlayer(player: Player, lineup: LineUp, i: number) {
  //   player.gamesPlayed.push({gameJerseyNumber: player.jerseyNumber});
  //   // if(lineup === this.homeLineup) {
  //   //   this.homeActiveStatuses[i] = true;
  //   // } else {
  //   //   this.awayActiveStatuses[i] = true;
  //   // }
  // }
}
